const generalPanes = {
  basic: {
    position: 0,
    isWhite: true,
  },
  outside: {
    name: 'outside',
    position: 0,
    isWhite: true,
    outOfMeeting: true,
  },
  lobby: {
    name: 'lobby',
    position: 1,
    isWhite: true,
  },
  waitingRoom: {
    name: 'waitingRoom',
    position: 1,
    isWhite: true,
  },
  endBar: {
    name: 'endBar',
    position: 6,
    isWhite: true,
  },
  skillBar: {
    name: 'skillBar',
    position: 5,
  },
  hamburger: {
    name: 'hamburger',
    inHamburger: true,
    hasClose: true,
    position: 12,
    isWhite: true,
  },
  microskills: {
    name: 'microskills',
    inHamburger: true,
    hasClose: true,
    position: 2,
    isWhite: true,
  },
  po3: {
    name: 'po3',
    inHamburger: true,
    hasClose: true,
    position: 11,
    isWhite: true,
    backTo: 'base',
  },
};

const editPanes = {
  name: {
    name: 'name',
    isEditPane: true,
    noInterrupt: true,
    hasClose: true,
    backTo: 'po3',
    position: 15,
    isWhite: true,
  },
  purpose: {
    name: 'purpose',
    isEditPane: true,
    noInterrupt: true,
    hasClose: true,
    backTo: 'po3',
    position: 15,
    isWhite: true,
  },
  objectives: {
    name: 'objectives',
    isEditPane: true,
    noInterrupt: true,
    hasClose: true,
    backTo: 'po3',
    position: 15,
    isWhite: true,
  },
  outputs: {
    name: 'outputs',
    isEditPane: true,
    noInterrupt: true,
    hasClose: true,
    backTo: 'po3',
    position: 15,
    isWhite: true,
  },
  outcomes: {
    name: 'outcomes',
    isEditPane: true,
    noInterrupt: true,
    hasClose: true,
    backTo: 'po3',
    position: 15,
    isWhite: true,
  },
  checkInQuestion: {
    name: 'checkInQuestion',
    isEditPane: true,
    noInterrupt: true,
    hasClose: true,
    backTo: 'skillBar',
    position: 15,
    isWhite: true,
  },
  proposal: {
    name: 'proposal',
    isEditPane: true,
    noInterrupt: false,
    hasClose: true,
    backTo: 'skillBar',
    position: 15,
    isWhite: true,
  },
  topic: {
    name: 'topic',
    isEditPane: true,
    noInterrupt: false,
    hasClose: true,
    backTo: 'skillBar',
    position: 15,
    isWhite: true,
  },
};

const overLayPanes = {
  meetingTime: {
    name: 'meetingTime',
    noBackTo: true,
    inHamburger: true,
    hasClose: true,
    position: 40,
    isWhite: true,
  },
  settings: {
    name: 'settings',
    noBackTo: true,
    inHamburger: true,
    hasClose: true,
    position: 50,
    temp: true,
    isWhite: true,
  },
  emoteGrid: {
    name: 'emoteGrid',
    noBackTo: true,
    inHamburger: true,
    hasClose: true,
    position: 60,
    temp: true,
    isWhite: true,
  },
  participantList: {
    name: 'participantList',
    noBackTo: true,
    inHamburger: true,
    hasClose: true,
    position: 70,
    isWhite: true,
  },
  spaces: {
    name: 'spaces',
    noBackTo: true,
    noInterrupt: false,
    inHamburger: true,
    hasClose: true,
    position: 60,
    isWhite: true,
  },
};

const sidebarPanes = {
  ...editPanes,
  ...overLayPanes,
  ...generalPanes,
};

export default sidebarPanes;
